// extracted by mini-css-extract-plugin
export default {"header":"header__header___2E1QC"};